document.addEventListener("turbo:load", () => {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf("safari") != -1) {
    if (ua.indexOf("chrome") > -1) {
      document.body.classList.add("browser-chrome");
    } else {
      document.body.classList.add("browser-safari");
    }
  }

  var inputBox = document.querySelector("body.browser-safari #inputBox");
  if (inputBox) {
    inputBox.addEventListener("focus", function (e) {
      document.body.classList.add("keyboard");
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 200);
    });

    inputBox.addEventListener("blur", function (e) {
      document.body.classList.remove("keyboard");
    });
  }
});
